// CHANGES TO THIS FILE MAY CAUSE INCORRECT BEHAVIOR AND WILL BE LOST IF THE CODE IS REGENERATED
// auto-generated on 9/3/2024 7:15:58 AM by John Caccavaro's (caccavaro123@gmail.com) Frameworks tool.

/* eslint-disable @typescript-eslint/no-empty-interface */

import { CultureTypeEnum } from '../schema/Schema';
import { TimeZoneTypeEnum } from '../schema/Schema';
import { EmailTypeEnum } from '../schema/Schema';
import { ContentTemplateTypeEnum } from '../../../notification/models/schema/Schema';
import { SecurityRoleTypeEnum } from '../schema/Schema';

export enum PersonPreferenceTypeEnum {
  notDefined = 0,
  general = 1,
  security = 2,
}

export enum GetPersonPreferencesRequestEnum {
  invalidCompanyId = 0,
  invalidPersonId = 1,
  invalidPreferenceType = 2,
}

export enum PersistPreferencesRequestEnum {
  invalidCompanyId = 0,
  invalidPersonId = 1,
}

export enum SendVerificationEmailRequestEnum {
  emailEmpty = 0,
}

export enum VerifyEmailRequestEnum {
  emailEmpty = 0,
  emailVerificationKeyEmpty = 1,
}

export enum PersistPersonProfileEnum {
  invalidCompanyId = 0,
  invalidPersonId = 1,
}

export enum GetAdminPreferencesEnum {
  invalidCompanyId = 0,
  invalidPersonId = 1,
  invalidPreferenceType = 2,
}

export enum GetClientNotificationListEnum {
  invalidCompanyId = 0,
  invalidPersonId = 1,
}

export enum PersistClientNotificationListEnum {
  invalidCompanyId = 0,
  invalidPersonId = 1,
}

export enum GetFirmPreferencesEnum {
  invalidCompanyId = 0,
  invalidPersonId = 1,
}

export enum SetMigrationDontShowmeFlagEnum {
  invalidCompanyId = 0,
  invalidPersonId = 1,
  invalidFlag = 2,
  personNotFound = 3,
}

export enum GetMigrationDontShowmeFlagEnum {
  invalidCompanyId = 0,
  invalidPersonId = 1,
  personNotFound = 2,
}

export interface GetPersonPreferencesRequestInterface {
  personId: number;
  companyId: number;
  preferenceType: PersonPreferenceTypeEnum;
  includePersonEmailList: boolean;
}

export interface GetPersonPreferencesResponseInterface {
  personEmailList: Array<string>;
  generalPreferences: GeneralPreferencesInterface;
  securityPreferences: SecurityPreferencesInterface;
  validationResults: ValidationResultsInterface;
}

export interface GeneralPreferencesInterface {
  cultureType: CultureTypeEnum;
  timeZoneType: TimeZoneTypeEnum;
  notificationEmail: string;
  personNotificationTypeList: Array<PersonNotificationTypeInterface>;
}

export interface PersistPreferencesRequestInterface {
  personId: number;
  companyId: number;
  generalPreferences: GeneralPreferencesInterface;
  securityPreferences: SecurityPreferencesInterface;
}

export interface PersistPreferencesResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface SecurityPreferencesInterface {
  emailList: Array<EmailInterface>;
}

export interface EmailInterface {
  emailAddress: string;
  emailType: EmailTypeEnum;
  isVerified: boolean;
}

export interface PersonNotificationTypeInterface {
  contentTemplateType: ContentTemplateTypeEnum;
  isEnabled: boolean;
  description: string;
  isApplicable: boolean;
}

export interface SendVerificationEmailRequestInterface {
  email: string;
}

export interface SendVerificationEmailResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface VerifyEmailRequestInterface {
  emailVerificationKey: string;
  email: string;
}

export interface VerifyEmailResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface PersistPersonProfileRequestInterface {
  personId: number;
  companyId: number;
  firstname: string;
  lastname: string;
  generalPreferences: GeneralPreferencesInterface;
  securityPreferences: SecurityPreferencesInterface;
}

export interface PersistPersonProfileResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface GetAdminPreferencesRequestInterface {
  personId: number;
  companyId: number;
  preferenceType: PersonPreferenceTypeEnum;
  includePersonEmailList: boolean;
  securityRoleType: SecurityRoleTypeEnum;
}

export interface GetAdminPreferencesResponseInterface {
  personEmailList: Array<string>;
  generalPreferences: GeneralPreferencesInterface;
  securityPreferences: SecurityPreferencesInterface;
  validationResults: ValidationResultsInterface;
}

export interface GetClientNotificationListRequestInterface {
  companyId: number;
  personId: number;
  securityRoleType: SecurityRoleTypeEnum;
}

export interface GetClientNotificationListResponseInterface {
  personNotificationTypeList: Array<PersonNotificationTypeInterface>;
  validationResults: ValidationResultsInterface;
}

export interface PersistClientNotificationListRequestInterface {
  companyId: number;
  personId: number;
  personNotificationTypeList: Array<PersonNotificationTypeInterface>;
}

export interface PersistClientNotificationListResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface GetFirmPreferencesRequestInterface {
  personId: number;
  companyId: number;
  preferenceType: PersonPreferenceTypeEnum;
  includePersonEmailList: boolean;
  securityRoleType: SecurityRoleTypeEnum;
}

export interface GetFirmPreferencesResponseInterface {
  personEmailList: Array<string>;
  generalPreferences: GeneralPreferencesInterface;
  securityPreferences: SecurityPreferencesInterface;
  validationResults: ValidationResultsInterface;
}

export interface GetMigrationPreferenceRequestInterface {
  companyId: number;
  personId: number;
}

export interface GetMigrationPreferenceResponseInterface {
  dontShowMeFlags: number;
  validationResults: ValidationResultsInterface;
}

export interface SetMigrationPreferenceRequestInterface {
  companyId: number;
  personId: number;
  flag: number;
  addFlag: boolean;
}

export interface SetMigrationPreferenceResponseInterface {
  dontShowMeFlags: number;
  validationResults: ValidationResultsInterface;
}

export enum ValidationSeverityEnum {
  NotDefined = 0,
  Passed,
  Information,
  Warning,
  Error,
}

export interface ValidationResultInterface {
  validationSeverityEnum: ValidationSeverityEnum;
  validationMessage: string;
  exceptionInformation: string;
  validationCode: number;
  validationTag: string;
  isValid: boolean;
}

export interface ValidationResultsInterface {
  validationResultList?: Array<ValidationResultInterface>;
}

import { Post } from '../../../httpClient';

export class PersonSettingsAccessService {
  getPersonPreferences(request: GetPersonPreferencesRequestInterface): Promise<GetPersonPreferencesResponseInterface> {
    return Post('/AppCorePersonSettingsAccess/getPersonPreferences', request);
  }

  persistPreferences(request: PersistPreferencesRequestInterface): Promise<PersistPreferencesResponseInterface> {
    return Post('/AppCorePersonSettingsAccess/persistPreferences', request);
  }

  sendVerificationEmail(
    request: SendVerificationEmailRequestInterface
  ): Promise<SendVerificationEmailResponseInterface> {
    return Post('/AppCorePersonSettingsAccess/sendVerificationEmail', request);
  }

  verifyEmail(request: VerifyEmailRequestInterface): Promise<VerifyEmailResponseInterface> {
    return Post('/AppCorePersonSettingsAccess/verifyEmail', request);
  }

  persistPersonProfile(request: PersistPersonProfileRequestInterface): Promise<PersistPersonProfileResponseInterface> {
    return Post('/AppCorePersonSettingsAccess/persistPersonProfile', request);
  }

  getAdminPreferences(request: GetAdminPreferencesRequestInterface): Promise<GetAdminPreferencesResponseInterface> {
    return Post('/AppCorePersonSettingsAccess/getAdminPreferences', request);
  }

  getClientNotificationList(
    request: GetClientNotificationListRequestInterface
  ): Promise<GetClientNotificationListResponseInterface> {
    return Post('/AppCorePersonSettingsAccess/getClientNotificationList', request);
  }

  persistClientNotificationList(
    request: PersistClientNotificationListRequestInterface
  ): Promise<PersistClientNotificationListResponseInterface> {
    return Post('/AppCorePersonSettingsAccess/persistClientNotificationList', request);
  }

  getFirmPreferences(request: GetFirmPreferencesRequestInterface): Promise<GetFirmPreferencesResponseInterface> {
    return Post('/AppCorePersonSettingsAccess/getFirmPreferences', request);
  }

  getMigrationPreference(
    request: GetMigrationPreferenceRequestInterface
  ): Promise<GetMigrationPreferenceResponseInterface> {
    return Post('/AppCorePersonSettingsAccess/getMigrationPreference', request);
  }

  setMigrationPreference(
    request: SetMigrationPreferenceRequestInterface
  ): Promise<SetMigrationPreferenceResponseInterface> {
    return Post('/AppCorePersonSettingsAccess/setMigrationPreference', request);
  }
}

export default new PersonSettingsAccessService();
